<template>
	<div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.name">
		<div class="text-right leading-tight hidden sm:block">
			<p class="font-semibold">{{ activeUserInfo.name }}</p>
			<small></small>
		</div>

		<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
			<div class="con-img ml-3">
				<img v-if="activeUserInfo.avatar || activeUserInfo.photoURL" key="onlineImg" :src="getAvatar()" alt="Avt" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
			</div>

			<vs-dropdown-menu class="vx-navbar-dropdown">
				<ul style="min-width: 9rem">
					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/pages/profile').catch(() => {})">
						<feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
						<span class="ml-2">Thông tin</span>
					</li>
					<vs-divider class="m-1" />

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
						<feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
						<span class="ml-2">Đăng xuất</span>
					</li>
				</ul>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		}
	},
	methods: {
		getAvatar() {
			let avtPath = '';
			let user = this.$store.state.AppActiveUser;
			if (user && user.avatar) {
				if (typeof user.avatar == 'string') {
					avtPath = user.avatar;
				}
				if (typeof user.avatar == 'object') {
					avtPath = user.avatar.path || '';
				}
				avtPath = user.photoURL || '';
			}
			if (avtPath == '') {
				avtPath = 'https://spp.agriindex.vn/storage/app/uploads/public/62f/125/53a/62f12553a5fe7841250944.png';
			}
			return avtPath;
		},
		async logout() {
			// await this.$router.push("/").catch(() => {});
			// If JWT login
			if (localStorage.getItem("accessToken")) {
				localStorage.removeItem("accessToken");
				// this.$router.push("/pages/login").catch(() => {});
			}

			// Change role on logout. Same value as initialRole of acj.js
			this.$acl.change("guest");
			localStorage.removeItem("userInfo");

			// This is just for demo Purpose. If user clicks on logout -> redirect
			this.$router.push("/pages/login").catch(() => {});
			// location.reload();
			window.location = '/';
		}
	}
};
</script>
